// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-919dac4e] .whodas-title .dot {\n  background-color: white !important;\n}\n[data-v-919dac4e] .whodas-title .dot .title-icon {\n  color: #ff7058 !important;\n}", ""]);
// Exports
module.exports = exports;
